'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

const msToMinute = (ms) => Math.floor(ms / constants.MS_MINUTE);
const msToHour = (ms) => Math.floor(ms / constants.MS_HOUR);

exports.msToHour = msToHour;
exports.msToMinute = msToMinute;
//# sourceMappingURL=convert.js.map
